var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigmaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 13C3.492 13 4.5 12.0293 4.5 10.8333V8.66663H2.25C1.008 8.66663 0 9.63729 0 10.8333C0 12.0293 1.008 13 2.25 13Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.50004C0 5.30404 1.008 4.33337 2.25 4.33337H4.5V8.66671H2.25C1.008 8.66671 0 7.69604 0 6.50004Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.16667C0 0.970667 1.008 0 2.25 0H4.5V4.33333H2.25C1.008 4.33333 0 3.36267 0 2.16667Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0H6.75C7.992 0 9 0.970667 9 2.16667C9 3.36267 7.992 4.33333 6.75 4.33333H4.5V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.50004C9 7.69604 7.992 8.66671 6.75 8.66671C5.508 8.66671 4.5 7.69604 4.5 6.50004C4.5 5.30404 5.508 4.33337 6.75 4.33337C7.992 4.33337 9 5.30404 9 6.50004Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 13,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaIcon);
export default __webpack_public_path__ + "static/media/figma-icon.69517469629494132f54de51b1700763.svg";
export { ForwardRef as ReactComponent };